<template lang='pug'>
div(:class='$style[`cc-order-container`]')
  div(:class='$style[`cc-order-banner`]')
    div(:class='$style[`cc-banner-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        //- IconCcoin(:size='64')
        span.no-wrap 交易
        span.font-doctor-theme 紀
        span.font-normal-theme 錄

  div(v-if='!loginStatus' :class='$style[`cc-order-wrap`]')
    span(:class='$style[`cc-order-login-first`]') 資料讀取失敗！
    button.btn-extra.font-medium(tabindex='0' aria-label='請先登入或註冊' :class='$style[`cc-order-login-btn`]' @click='handleLoginBtn') 👉 請先登入 / 註冊

  div(v-else :class='$style[`cc-order-wrap`]')
    div(:class='$style[`cc-order-navbar`]')
      button(tabindex='0' aria-label='付費交易' :class='[$style[`cc-order-navbar-btn`], $style[orderType === `pay` ? `isActive` : ``]]' @click='handleClickSwitchOrderType(`pay`)')
        IconMoney(:size='26')
        span 付費交易
      button(tabindex='0' aria-label='C幣兌換' :class='[$style[`cc-order-navbar-btn`], $style[orderType === `convert` ? `isActive` : ``]]' @click='handleClickSwitchOrderType(`convert`)')
        IconCcoin(:size='26')
        span C幣兌換


    div(v-if='preLoading' :class='$style[`cc-order-preloader`]')
      IconLoading(:size='36' :color='`#b1b1b1`')

    div(v-else :class='$style[`cc-order-product`]')
      div(v-if='emptyShop' :class='$style[`cc-order-product-empty`]')
        figure.graphic.graphic-empty(:class='$style[`cc-order-product-empty-graphic`]')
        span!= '查無資料'

      div(v-else :class='$style[`cc-order-product-container`]')

        ul(v-if='orderType === `pay`' :class='$style[`cc-order-product-ul`]')
          li(v-for='items, index in myOrder' :key='index' :class='$style[`cc-order-product-li`]')
            OrderPay(:stuffId='items.id' :stuffDetail='items' @detectStatusChange='emitStatusChange')

        ul(v-else :class='$style[`cc-order-product-ul`]')
          li(v-for='items, index in myOrder' :key='index' :class='$style[`cc-order-product-li`]')
            OrderConvert(:stuffId='items.id' :stuffDetail='items' @detectStatusChange='emitStatusChange')

        //- LazyLoad
        infinite-loading(:identifier='infiniteId' @infinite='infiniteHandler')
          div(slot='spinner')
            IconLoading(
              slot='spinner'
              :size='30'
              :color='`#b1b1b1`')

          div.infinite-scroll-slot(slot='no-more' style='padding: 10px 0')
            span.infinite-scroll-slot-noMore 沒有更多資料

          div.infinite-scroll-slot(slot='no-results' style='padding: 10px 0')
            span.infinite-scroll-slot-noMore 沒有更多資料



</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import IconCcoin from '../../icon/Ccoin';
import IconMoney from '../../icon/Money';
import IconOpenArrow from '../../icon/OpenArrow';
import IconLoading from '../../icon/Loading';
import OrderPay from './OrderPay';
import OrderConvert from './OrderConvert';

import {
  getEcpayUserOrderList,
  getConvertUserOrderList,
} from '../../../js/restapi';

export default {
  metaInfo() {
    return {
      title: '交易紀錄',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/orders',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/orders',
      }],
    };
  },

  components: {
    IconCcoin,
    IconMoney,
    IconLoading,
    IconOpenArrow,
    OrderPay,
    OrderConvert,
  },

  created() {
    if (!this.loginStatus) {
      this.changePopBoxStatus({
        active: true,
        include: 'login',
      });
      return;
    }
    this.axiosReadPayOrderList();
  },

  data() {
    return {
      preLoading: true,
      emptyShop: false,
      myOrder: [],

      orderType: 'pay', // free

      pageSize: 6,
      pageIndex: 1,

      nextTick: 1,
      infiniteId: +new Date(),
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    infiniteHandler($state) {
      if (!this.preLoading) {
        if (this.orderType === 'pay') {
          getEcpayUserOrderList(`/?size=${this.pageSize}&page=${this.pageIndex}`, {
            auth_id: `${this.loginDjangoId}`,
            start: '2020.12',
            end: '3500.12'
          })
            .then((res) => {
              res.data.results.map((x) => this.myOrder.push(x));
              console.log('LazyLoad Success', this.myOrder);
  
              if (res.data.results.length < this.pageSize || this.myOrder.length === res.data.count) {
                $state.complete();
              } else {
                this.pageIndex += 1;
              }
              $state.loaded();
            })
            .catch((err) => {
              console.log('getEcpayUserOrderList Error', this.myOrder);
            })
        } else {
          getConvertUserOrderList(`/?size=${this.pageSize}&page=${this.pageIndex}`, {
            auth_id: `${this.loginDjangoId}`,
            start: '2020.12',
            end: '3500.12'
          })
            .then((res) => {
              res.data.results.map((x) => this.myOrder.push(x));
              console.log('LazyLoad Success', this.myOrder);
  
              if (res.data.results.length < this.pageSize || this.myOrder.length === res.data.count) {
                $state.complete();
              } else {
                this.pageIndex += 1;
              }
              $state.loaded();
            })
            .catch((err) => {
              console.log('getEcpayUserOrderList Error', this.myOrder);
            })
        }
      } else {
        $state.complete();
      }
    },

    axiosReadPayOrderList() {
      getEcpayUserOrderList(`/?size=${this.pageSize}&page=${this.pageIndex}`, {
        auth_id: `${this.loginDjangoId}`,
        start: '2020.12',
        end: '3500.12'
      })
        .then((res) => {
          if (!res.data.count) {
            this.emptyShop = true;
          } else {
            this.myOrder = res.data.results;
            console.log('getEcpayUserOrderList Success', this.myOrder);

            this.pageIndex += 1;
          }

          this.preLoading = false;
        })
        .catch((err) => {
          console.log('getEcpayUserOrderList Error', this.myOrder);
          this.preLoading = false;
        })
    },

    axiosReadConvertOrderList() {
      getConvertUserOrderList(`/?size=${this.pageSize}&page=${this.pageIndex}`, {
        auth_id: `${this.loginDjangoId}`,
        start: '2020.12',
        end: '3500.12',
      })
        .then((res) => {
          if (!res.data.count) {
            this.emptyShop = true;
          } else {
            this.myOrder = res.data.results;
            console.log('getConvertUserOrderList Success', this.myOrder);
            this.pageIndex += 1;
          }

          this.preLoading = false;
        })
        .catch((err) => {
          console.log('getConvertUserOrderList Error', this.myOrder);
          this.preLoading = false;
        })
    },

    emitStatusChange() {
      console.log('emitStatusChange');
      this.nextTick += 1;
    },

    handleLoginBtn() {
      this.changePopBoxStatus({
        active: true,
        include: 'login',
      });
    },

    handleClickSwitchOrderType(type) {
      this.preLoading = true;
      this.orderType = type;
      this.emptyShop = false;
      this.myOrder = [];
      this.pageIndex = 1;

      switch (type) {
        case 'pay':
          this.axiosReadPayOrderList();
          break;

        case 'convert':
        this.axiosReadConvertOrderList();
          break;
      
        default:
          break;
      }

      if(this.$refs.infiniteHandler){
        this.$refs.infiniteHandler.stateChanger.reset(); 
      }
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      // authJwtToken: 'user/exportUserJwtToken',
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      // loginProfile: 'user/exportUserProfile',
    }),
  },

  watch: {
    loginStatus() {
      console.log('首頁登入狀態 發現轉換!');
      if (this.loginStatus) {
        this.axiosReadPayOrderList();
      }
    },

    nextTick() {
      this.pageIndex = 1,
      this.myOrder = [];
      this.axiosReadPayOrderList();
    }
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/account/order.scss';
</style>
